module.exports = __webpack_public_path__ + "assets/img/99faa940fff12c6b55324b475131f86c.png";